import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  tr,
  th,
  td,
  thead,
  Table,
  div,
  tbody,
  Button,
  Alert,
  DropdownButton,
  MenuItem,
  FormGroup,
  InputGroup,
  FormControl,
  Modal,
  ControlLabel,
  ButtonGroup,
  Glyphicon
} from "react-bootstrap";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../../components";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { withRouter, Link } from "react-router-dom";
import {
  getAffiliateList,
  deleteAffiliate
} from "../../../../redux/actions/affiliateActions";
import { Notification } from "../../../../components/notifications";
import isEmpty from "lodash.isempty";
import Pagination from "react-paginating";
import "../../../../style/react-paginating.css";
import moment from "moment";
import AffiliateDashboard from "../../../affiliate/dashboard";
import {
  renderAlert,
  clearAlert
} from "../../../../redux/actions/alertsActions";
import Dialog from "react-bootstrap-dialog";
import "../../../../style/listPage.scss";
import {aclUtil} from "../../../util"

const history = createBrowserHistory();
class AffiliateList extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      menuKey: 'LIST_AFFILIATE',
      affiliateList: [],
      totalRecords: 0,
      limit: 25,
      search: "",
      perPage: 0,
      currentPage: 1,
      pageCount: 0,
      alertMessage: "",
      msgType: "success",
      legal_nameSortIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      account_nameSortIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      emailSortIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      deal_citySortIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      registeredOnSortIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      path: ["Home", "Manage Affiliate List"],
      links: ["home", "affiliateList"],
      show: false,
      direction: "",
      orderBy: ""
    };
    this.handleSelect = this.handleSelect.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleSelect(limit) {
    this.setState({
      limit: limit
    });
    const postData = {
      page: this.state.currentPage,
      limit: this.state.limit,
      search: this.state.search
    };

    this.props.getAffiliateList(postData);
  }

  handleSearch(e) {
    this.setState({ [e.target.name]: e.target.value });
    let searchstring = this.state.search.length > 1 ? this.state.search : "";
    const postData = {
      page: "1",
      limit: this.state.limit,
      search: searchstring
    };

    if (this.state.search.length !== 0) {
      this.props.getAffiliateList(postData);
    } else {
      this.props.getAffiliateList({ page: this.state.currentPage,limit: this.state.limit });
    }
  }

  handleSort = orderBy => e => {
    e.preventDefault();

    let direction;
    const sortIcon = `${orderBy}SortIcon`;
    if (this.state.direction === "") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-sort-by-attributes",
        direction: "ASC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "ASC") {
      direction = "DESC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-sort-by-attributes-alt",
        direction: "DESC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "DESC") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-sort-by-attributes",
        direction: "ASC",
        orderBy: orderBy
      });
    }
    this.props.getAffiliateList({ orderBy: orderBy, direction: direction,limit: this.state.limit });
  };

  handlePageChange = page => {
    this.setState({
      currentPage: page
    });

    const postData = {
      page: page,
      limit: this.state.limit,
      search: this.state.search ? this.state.search : ""
    };
    this.props.getAffiliateList(postData);
  };

  componentWillMount() {
    this.handleDismiss();
    this.props.clearAlert();
    this.props.getAffiliateList({ page: this.state.currentPage,limit: this.state.limit });
  }

  componentWillReceiveProps(nextProps) {
    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.context.router.history.push("/restrictedAccess");
    }
    if (this.props.affiliateList !== nextProps.affiliateList) {
      if (nextProps.affiliateList) {
        const setPageCount =
          nextProps.affiliateList.total / nextProps.affiliateList.per_page;
        this.setState({
          affiliateList: nextProps.affiliateList.data,
          totalRecords: nextProps.affiliateList.total,
          perPage: nextProps.affiliateList.per_page,
          pageCount: setPageCount
        });
      }
    }

    if (this.props.deletedaffiliate !== nextProps.deletedaffiliate) {
      if (!isEmpty(nextProps.deletedaffiliate)) {
        this.props.clearAlert();
        this.handleShow();
        this.props.getAffiliateList({ page: this.state.currentPage,limit: this.state.limit });
        this.props.renderAlert("success", nextProps.deletedaffiliate.message);
      }
    }
    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
      }
    }

    if (this.props.message !== nextProps.message) {
      if (nextProps.message) {
        this.setState({
          alertMessage: nextProps.message,
          msgType: nextProps.alertType
        });
      }
    }
  }

  handleDelete = affiliateID => {
    this.dialog.show({
      body: "Are you sure you want to delete this?",
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          this.confirmDelete(affiliateID);
          this.handleShow();
        })
      ]
    });
  };

  confirmDelete = affiliateID => {
    this.props.deleteAffiliate(affiliateID);
    this.props.getAffiliateList({ page: this.state.currentPage,limit: this.state.limit });
  };

  redirectDashboard = affiliateID => {
    if (affiliateID) {
    }
  };

  redirectToWebSite = websiteUrl => {
    if (websiteUrl !== "http://") {
      var win = window.open(websiteUrl, "_blank");
      win.focus();
    }
  };

  render() {
    const { path } = this.state;
    const { currentPage, totalRecords, perPage, pageCount } = this.state;
    let affiliateRow;
    let affliliateListData = this.state.affiliateList
      ? this.state.affiliateList
      : [];

    if (!isEmpty(affliliateListData)) {
      affiliateRow = affliliateListData.map((affiliate, index) => (
        <tr key={affiliate.affiliateID}>
          <td>{affiliate.account_name}</td>
          <td>{affiliate.email}</td>
          <td>
            <Link
              replace
              to={"/affiliateList"}
              onClick={this.redirectToWebSite.bind(this, affiliate.websiteUrl)}
            >
              {affiliate.websiteUrl}
            </Link>
          </td>
          <td> {affiliate.deal_city} </td>

          <td> {moment(affiliate.registeredOn).format("ll")}</td>
          <td> {affiliate.status} </td>
          <td>
            <ButtonGroup>
                <DropdownButton title="Action" id="bg-nested-dropdown">
                  {aclUtil.checkACL('VIEW_AFFILIATE') ? (<MenuItem eventKey={Math.random()} onClick={() => this.context.router.history.push(`/affiliate/dashboard/${affiliate.affiliateID}`)}><i className="glyphicon glyphicon-eye-open"></i> View</MenuItem>):("")}
                  {aclUtil.checkACL('EDIT_AFFILIATE') ? (<MenuItem eventKey={Math.random()} onClick={() => this.context.router.history.push(`/addAffiliate/${affiliate.affiliateID}`)}><i className="glyphicon glyphicon-pencil"></i> Edit</MenuItem>):("")}
                  {aclUtil.checkACL('DELETE_AFFILIATE') ? (<MenuItem eventKey={Math.random()} onClick={this.handleDelete.bind(this, affiliate.affiliateID)}><i className="glyphicon glyphicon-trash"></i> Delete</MenuItem>):("")}
                </DropdownButton>
            </ButtonGroup>
          </td>
        </tr>
      ));
    }

    return (
      <div>
        <Dialog
          ref={el => {
            this.dialog = el;
          }}
        />

        <div className="col-lg-12 list-page">
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
            </div>
          </div>
          <div className="panel">
            <header className="panel-heading panel-heading-index">
              <div className="row">
                <div className="col-lg-6 col-md-4 col-sm-12">
                  <h4>Affiliate List</h4>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-12">
                  <FormGroup>
                    <InputGroup>
                      <FormControl type="text" name="search" onKeyUp={this.handleSearch} />
                      <InputGroup.Addon>
                        <Glyphicon glyph="glyphicon glyphicon-search" />
                      </InputGroup.Addon>
                    </InputGroup>
                  </FormGroup>
                </div>
                <div className="col-lg-2 col-md-4 col-sm-12">
                  {aclUtil.checkACL('ADD_AFFILIATE') ? (
                    <Button className="addMerchant"
                      bsSize="small"
                      bsStyle="success"
                      onClick={() => this.context.router.history.push("/addAffiliate")}
                    >
                      + Add Affiliate
                    </Button>)
                    : ("")}
                </div>
              </div>
            </header>
            <div className="panel-body">
              {this.state.show &&
                this.state.alertMessage !== "" && (
                  <div className="col-lg-12">
                    <Alert
                      bsStyle={this.state.msgType}
                      onDismiss={this.handleDismiss}
                    >
                      <strong>{this.state.msgType}:</strong>{" "}
                      {this.state.alertMessage}
                    </Alert>
                  </div>
                )}
              <div className="row">
                <div className="col-lg-12">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th onClick={this.handleSort("account_name")}>
                          Account Name{" "}
                          <i className={this.state.account_nameSortIcon} />
                        </th>
                        <th onClick={this.handleSort("email")}>
                          Email <i className={this.state.emailSortIcon} />
                        </th>
                        <th>Website</th>
                        <th onClick={this.handleSort("deal_city")}>
                          Market <i className={this.state.deal_citySortIcon} />
                        </th>
                        <th onClick={this.handleSort("registeredOn")}>
                          Applied At{" "}
                          <i className={this.state.registeredOnSortIcon} />
                        </th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>{affiliateRow}</tbody>
                  </table>

                  <div className="text-center">
                    <Pagination
                      total={totalRecords}
                      limit={perPage}
                      pageCount={5}
                      currentPage={currentPage}
                    >
                      {({
                        pages,
                        currentPage,
                        hasNextPage,
                        hasPreviousPage,
                        previousPage,
                        nextPage,
                        totalPages,
                        getPageItemProps
                      }) => (
                        <div className="pagination">
                          <button className="btn btn-default"
                            {...getPageItemProps({
                              pageValue: 1,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            first
                          </button>

                          {hasPreviousPage && (
                            <button className="btn btn-default"
                              {...getPageItemProps({
                                pageValue: previousPage,
                                onPageChange: this.handlePageChange
                              })}
                            >
                              {"<"}
                            </button>
                          )}

                          {pages.map(page => {
                            let activePage = null;
                            if (currentPage === page) {
                              activePage = {
                                backgroundColor: "#ccc",
                                color: "#666"
                              };
                            }
                            return (
                              <button className="btn btn-default"
                                key={page}
                                style={activePage}
                                {...getPageItemProps({
                                  pageValue: page,
                                  onPageChange: this.handlePageChange
                                })}
                              >
                                {page}
                              </button>
                            );
                          })}

                          {hasNextPage && (
                            <button className="btn btn-default"
                              {...getPageItemProps({
                                pageValue: nextPage,
                                onPageChange: this.handlePageChange
                              })}
                            >
                              {">"}
                            </button>
                          )}

                          <button className="btn btn-default"
                            {...getPageItemProps({
                              pageValue: totalPages,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            last
                          </button>
                        </div>
                      )}
                    </Pagination>
                  </div>
                </div>
              </div>
              <div className="clearfix" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

AffiliateList.propTypes = {
  getAffiliateList: PropTypes.func.isRequired,
  deleteAffiliate: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  affiliateList: state.affiliateReducer.affiliateList,
  deletedaffiliate: state.affiliateReducer.deletedaffiliate,
  error: state.affiliateReducer.error,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message
});

export default connect(mapStateToProps, {
  getAffiliateList,
  deleteAffiliate,
  renderAlert,
  clearAlert
})(AffiliateList);



// WEBPACK FOOTER //
// ./src/app/views/admin/marketing/affiliates/AffiliateList.js